export default "/_next/static/images/service-premium-3x-25ea28ff62752808726fb96ceec7f4bd.png";